export class FailedDependencyError extends Error {
  constructor(message = '') {
    super(message || 'A solicitação não pôde ser concluída devido a uma ou mais dependencias que falharam.')
    this.name = 'failedDependency'
  }
}
